import {AbstractStorage} from "../../services/storage/abstract-storage";
import {SessionStorageService} from "../../services/storage/session-storage";

export interface IPersistScrollPositionData {
  scrollTop: number,
  windowWidth: number,
}

export class PersistScrollRepository {
  constructor(private storage: AbstractStorage = new SessionStorageService()) {
  }

  private prefixKey(key: string): string {
    return `scroll:${key}`;
  }

  public getScrollData(key: string): IPersistScrollPositionData | undefined {
    return this.storage.getJsonItem<IPersistScrollPositionData>(this.prefixKey(key));
  }

  public saveScrollData(key: string, scrollPositionData: IPersistScrollPositionData): void {
    this.storage.setJsonItem<IPersistScrollPositionData>(this.prefixKey(key), scrollPositionData);
  }

  public removeScrollData(key: string): void {
    this.storage.removeItem(this.prefixKey(key));
  }
}

export const persistScrollRepository = new PersistScrollRepository();
export const persistScrollSessionRepository = new PersistScrollRepository(new SessionStorageService);
